import React from 'react'
import Header from '../../../Components/Header'

function Profiles() {
    return (
        <div>
            <Header text={"Profiles"} link={'/datasheet/profiles'} />
            <div>
                Data
            </div> <br />
        </div>
    )
}

export default Profiles